import { useMemo } from 'react';

import { mapOddsMarketsWithDifferentKeys } from '../helpers/mapOddsMarketsWithDifferentKeys';

import { OddResponse, NormalizedOdd } from '../types/odds';

interface Props {
  odds: OddResponse[];
  dataOddsBettingId?: string | null;
  showOdds?: boolean;
}

const filterOddsByBettingIds = (odds: NormalizedOdd[], bettingIds?: string[]) => {
  // return first betting provider if betting id is not provided
  if (!bettingIds) return odds.length > 0 ? [odds[0]] : [];

  return odds.filter(({ bookmaker }: NormalizedOdd) => bettingIds.includes(`${bookmaker?.id}`)) || odds;
};

export const useProcessedOdds = ({ odds, dataOddsBettingId, showOdds }: Props) => {
  const processedOdds = useMemo(() => {
    if (!showOdds || odds.length === 0) return [];

    try {
      const processedOdds = mapOddsMarketsWithDifferentKeys(odds) ?? [];

      const bookmakerIds = odds.map(({ bookmaker }) => bookmaker?.id ?? '').filter((id) => id !== '');

      const bettingIds = dataOddsBettingId ? dataOddsBettingId.split(',').map((id) => id.trim()) : bookmakerIds;

      return bettingIds ? filterOddsByBettingIds(processedOdds, bettingIds) : processedOdds;
    } catch (error: unknown) {
      return [];
    }
  }, [odds, dataOddsBettingId, showOdds]);

  return processedOdds;
};
